import { DaoModel } from '@dynameat/models';

export class ForecastGroup extends DaoModel {
  constructor(guid, serviceGuid, date, codeName) {
    super(guid);
    this.serviceGuid = serviceGuid || '';
    this.date = date || null;
    this.codeName = codeName || null;
  }

  static toInstance(props = {}) {
    return new ForecastGroup(props.guid, props.service_guid, props.date, props.code_name);
  }

  serialize() {
    return {
      ...super.serialize(),
      service_guid: this.serviceGuid,
      date: this.date,
      code_name: this.codeName,
    };
  }
}
